import { Container, Box } from '@hover/blueprint';
import React, { useEffect, useRef, useState } from 'react';
import TabSectionDesktop from './TabsSectionDesktop';
import BetterSectionHeader from './BetterSectionHeader';
import TabSectionMobile from './TabSectionMobile';

const TABS_NAME = [
  'TOTAL PRIVACY',
  'VISUALIZE',
  'BETTER ESTIMATES',
  'TRANSPARENCY',
];

const TIMER = 9900;

const InvitedByContractorBetterSection: React.FC = () => {
  const [currentIndex, setCurrentTab] = useState<string>(TABS_NAME[0]);

  const timerRef: { current: null | ReturnType<typeof setTimeout> } =
    useRef(null);

  const handleChangeTab = () => {
    setCurrentTab(prevTab => {
      const prevTabIndex = TABS_NAME.findIndex(tabName => tabName === prevTab);
      if (prevTabIndex === TABS_NAME.length - 1) {
        return TABS_NAME[0];
      }
      return TABS_NAME[prevTabIndex + 1];
    });
  };

  useEffect(() => {
    timerRef.current = setInterval(handleChangeTab, TIMER);
    return () => clearInterval(timerRef.current as NodeJS.Timeout);
  }, []);

  const resetTimer = (title: string) => {
    if (timerRef.current) {
      clearInterval(timerRef.current);
    }
    setCurrentTab(() => {
      timerRef.current = setInterval(handleChangeTab, TIMER);
      return title;
    });
  };

  return (
    <Box
      w="100%"
      flexDir="column"
      alignItems="center"
      mb={{ base: 1000, tablet: '177px' }}
      overflow="hidden"
    >
      <Container maxW="7xl" centerContent>
        <BetterSectionHeader />
        <TabSectionDesktop
          currentIndex={currentIndex}
          resetTimer={resetTimer}
        />
      </Container>
      <TabSectionMobile currentIndex={currentIndex} resetTimer={resetTimer} />
    </Box>
  );
};

export default InvitedByContractorBetterSection;
